import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const EventProgressBarContainer = styled.div<React.CSSProperties>`
  background: rgba(255, 255, 255, 0.53);
  opacity: 1;
  height: ${12 * Screen.widthRatio}px;
  left: ${24 * Screen.widthRatio}px;
  width: ${302 * Screen.widthRatio}px;
  margin-top: ${12 * Screen.widthRatio}px;
  border-radius: ${10 * Screen.widthRatio}px;
`;

export default EventProgressBarContainer;
